import { render, staticRenderFns } from "./SchoolAddEdit.vue?vue&type=template&id=fc01f128"
import script from "./SchoolAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports